module.exports = __webpack_public_path__ + "img/logo-credit-experts.fc4bdeec.svg";